import * as React from "react";
import { useCallback, useContext } from "react";
import { MenuItem } from "components/bootstrap";
import WidgetContext from "views/components/contexts/WidgetContext";
import useSelectedMessageEntities from "views/hooks/useSelectedMessageEntities";
import useView from "views/hooks/useView";
import useAssistantSidebar from "ai/sidebar/useAssistantSidebar";
import {
  createSelectedMessagesSummaryRequest,
  MESSAGES_WIDGET_TYPE
} from "ai/widget-summary/createMessagesWidgetSummaryRequest";
import useWidgetSummaryUnavailableReason from "ai/widget-summary/useWidgetSummaryUnavailableReason";
export const MAX_SELECTED_MESSAGES = 50;
const SelectedMessagesSummaryBulkAction = () => {
  const widget = useContext(WidgetContext);
  const view = useView();
  const { selectedEntities } = useSelectedMessageEntities();
  const { openWidgetSummary } = useAssistantSidebar();
  const unavailableReason = useWidgetSummaryUnavailableReason(MESSAGES_WIDGET_TYPE);
  const disabledReason = unavailableReason != null ? unavailableReason : selectedEntities.length > MAX_SELECTED_MESSAGES ? `Select at most ${MAX_SELECTED_MESSAGES} messages to summarize.` : void 0;
  const onClick = useCallback(
    () => openWidgetSummary(createSelectedMessagesSummaryRequest(view, widget, selectedEntities)),
    [openWidgetSummary, selectedEntities, view, widget]
  );
  if (!widget) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(MenuItem, { icon: "note_add", disabled: !!disabledReason, title: disabledReason, onClick }, "Summarize selected messages");
};
export default SelectedMessagesSummaryBulkAction;
